import classNames from 'classnames';
import { useRouteMatch } from 'react-router-dom';

import { NavLayout } from '@layouts/NavLayout';
import { virtualCatalog } from '@urls';
import { VirtualCatalogContainer } from '@containers/catalog/VirtualCatalog';

import s from './VirtualCatalogPage.sss';

type MatchParams = {
  virtualCatalogSlug: string
};

type VirtualCatalogPageProps = {
  className?: string
};

export const VirtualCatalogPage: React.FC<VirtualCatalogPageProps> = ({
  className,
}) => {
  const match = useRouteMatch<MatchParams>(virtualCatalog);
  if (!match) {
    throw new Error('Not match');
  }
  const { virtualCatalogSlug } = match.params;

  return (
    <NavLayout className={classNames(s.root, className)}>
      <VirtualCatalogContainer slug={virtualCatalogSlug} />
    </NavLayout>
  );
};

export default VirtualCatalogPage;
